import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.10.0_3deaa5576ccbfaf05268e5bac8380424/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.10.0_3deaa5576ccbfaf05268e5bac8380424/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}